// Account Opening API
const login_account_opening = `{	
    "access_token": "eyJhbGciOiJSUzI1NiIsImtpZCI6IkYzOTM3QUZEMzBGMTE0RTAzMUM4NDdGQzdCM0Y0N0U3IiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2OTE3N",	
    "expires_in": 3600,	
    "token_type": "Bearer",	
    "scope": "example-api",	
    "publicKey": "-----BEGIN PUBLIC KEY-----\r\nEzlnuljcfLsS5adxy\r\nw/oX9nL89bOprC5mlgmn8sTEMc5ceF0HqO/iPwEVbQ/CLSYC1ucQYYVBqbNe8r4/\r\n2akAjplYZmpuB1gScQIDAQAB\r\n-----END PUBLIC KEY-----\r\n",	
    "aesKey": "UQJhoP0F6GzSQdCOmxPKyBGTJHVoi6gV",	
    "aesIV": "RuGV6tfE4ZelzX1i"	
    }`;
const list_all_resp_body = `[
    "AccountTermsConditions",
    "DayTradingRiskDisclosure",
    "ElectronicAccessTradingAgreement",
    "MarginAgreement",
    "MarginDisclosureStatement",
    "PassportVERIFICATIONGuideline",
    "PennyStockRiskDisclosure",
    "PersonalGuaranteeVC",
    "Stockslocateagreement",
    "TradingAddendumToCustomerAgreement",
    "W9Certification"
]`;
const get_options_details = `[
    {
        "optionId": 4,
        "code": "D",
        "description": "Driver License"
    },
    {
        "optionId": 4,
        "code": "L",
        "description": "Local ID"
    },
    {
        "optionId": 4,
        "code": "P",
        "description": "Passport"
    },
    {
        "optionId": 4,
        "code": "U",
        "description": "Utility Bill"
    }
]`;

const companyInitialRouteUrl = `f4e94-8fd8-5358e592-54b8-463b-93a2666eb5e`;
const beneficiaryRouteUrl = `89a625203e8-ffbb-7-435d62792d23`;
const fundingRouteUrl = `f25203e8-ffbb-4e94-4c49-bc14-`;
const signupInitialRouteUrl = `a94386d2-eae78fd8-5358e666eb5e3d170fb2aed7`;
const signupAccountRouteUrl = `a94386d2--3d170fb2aed7-4c49-bc14-3d17`;
const signupOtherRouteUrl = `a94386d2-eae7eae7-4c49-bc140fb2aed7`;
const allAccountRouteURL = `
{
    "identifierCode":"4ce8573a-bc537",
    "isBusinessEntity":true,
    "accountOpeningClientId":"User",
    "firmCode":"",
    "fullName":"John Doe",
    "email":"info@example.com",
    "status":"PENDING",
    "accountTypesAfterApproval":null,
    "backOfficeAccountNumbersAfterApproval":null,
    "reasonForCurrentStatus":"",
    "omsClientID":"",
    "omsUsername":"",
    "omsPassword":"",
    "applicationStartedDate":"01/01/0001 00:00:00",
    "applicationSubmittedDate":"01/01/0001 00:00:00",
    "applicationEndDate":"01/01/0001 00:00:00",
    "initialDataGathered":true,
    "initialDataGatheredDate":"01/01/0001 00:00:00",
    "accountFundingDataGathered":true,
    "accountFundingDataGatheredDate":"01/01/0001 00:00:00",
    "otherDataGathered":true,
    "otherDataGatheredDate":"01/01/0001 00:00:00",
    "lastUpdationDate":"01/01/0001 00:00:00",
    "accountTypes":[
       "M",
       "C"
    ],
    "lastAccountActionTakenBy":""
 }`;
const filterAccountRouteURL = `{
    "identifierCode": "a94386d2-eae770fb2aed7",
    "isBusinessEntity": false,
    "accountOpeningClientId": "User",
    "firmCode": "GDN",
    "fullName": "John Doe",
    "email": "info@example.com",
    "status": "PENDING",
    "accountTypesAfterApproval": null,
    "backOfficeAccountNumbersAfterApproval": null,
    "reasonForCurrentStatus": null,
    "omsClientID": null,
    "omsUsername": null,
    "omsPassword": null,
    "applicationStartedDate": "11/02/2022 08:51:45",
    "applicationSubmittedDate": "11/02/2022 09:05:53",
    "applicationEndDate": "01/01/0001 00:00:00",
    "initialDataGathered": true,
    "initialDataGatheredDate": "11/02/2022 08:51:45",
    "accountFundingDataGathered": true,
    "accountFundingDataGatheredDate": "11/02/2022 08:58:51",
    "otherDataGathered": true,
    "otherDataGatheredDate": "11/02/2022 09:05:53",
    "lastUpdationDate": "11/02/2022 09:05:53",
    "accountTypes": [
        "M"
    ],
    "lastAccountActionTakenBy": null
}`;

const documentlist = `[
    "AccountTermsConditions",
    "DayTradingRiskDisclosure",
    "ElectronicAccessTradingAgreement",
    "MarginAgreement",
    "MarginDisclosureStatement",
    "PassportVERIFICATIONGuideline",
    "PennyStockRiskDisclosure",
    "PersonalGuaranteeVC",
    "Stockslocateagreement",
    "TradingAddendumToCustomerAgreement",
    "W9Certification"
]`;

const singleDocLink = `https://example.com/AccountOpenngDisclosureDocuments`;
const apiOptionListAll = `[
    {
        "optionId": 1,
        "code": "1",
        "description": "InvestmentRiskTolerance"
    },
    {
        "optionId": 20,
        "code": "20",
        "description": "YearsOfExperience"
    },
    {
        "optionId": 19,
        "code": "19",
        "description": "AssetClass"
    },
    {
        "optionId": 18,
        "code": "18",
        "description": "TaxWithholdingCertifications"
    },
    {
        "optionId": 17,
        "code": "17",
        "description": "TimeToAchieveFinancialGoal"
    },
    {
        "optionId": 16,
        "code": "16",
        "description": "LiquidityNeeds"
    },
    {
        "optionId": 15,
        "code": "15",
        "description": "SpecialExpenses"
    },
    {
        "optionId": 14,
        "code": "14",
        "description": "AnnualExpenses"
    },
    {
        "optionId": 13,
        "code": "13",
        "description": "InvestmentObjectives"
    },
    {
        "optionId": 12,
        "code": "12",
        "description": "TaxRate"
    },
    {
        "optionId": 11,
        "code": "11",
        "description": "LiquidNetWorth"
    },
    {
        "optionId": 10,
        "code": "10",
        "description": "NetWorthExcludingResidence"
    },
    {
        "optionId": 9,
        "code": "9",
        "description": "AnnualIncome"
    },
    {
        "optionId": 8,
        "code": "8",
        "description": "IncomeSource"
    },
    {
        "optionId": 7,
        "code": "7",
        "description": "EmploymentStatus"
    },
    {
        "optionId": 6,
        "code": "6",
        "description": "TaxStatus"
    },
    {
        "optionId": 5,
        "code": "5",
        "description": "IsW8OrW9Forms"
    },
    {
        "optionId": 4,
        "code": "4",
        "description": "ValidGovtIDType"
    },
    {
        "optionId": 3,
        "code": "3",
        "description": "MaritalStatus"
    },
    {
        "optionId": 2,
        "code": "2",
        "description": "IdentificationProofType"
    },
    {
        "optionId": 21,
        "code": "21",
        "description": "Knowledge"
    },
    {
        "optionId": 22,
        "code": "22",
        "description": "JointIsW8OrW9Forms"
    },
    {
        "optionId": 23,
        "code": "23",
        "description": "GroupCode"
    }
]`;

const apiOptionDetails = `[
    {
        "optionId": 1,
        "code": "1",
        "description": "Conservative"
    },
    {
        "optionId": 1,
        "code": "2",
        "description": "Moderately Conservative"
    },
    {
        "optionId": 1,
        "code": "3",
        "description": "Moderate"
    },
    {
        "optionId": 1,
        "code": "4",
        "description": "Moderately Aggressive"
    },
    {
        "optionId": 1,
        "code": "5",
        "description": "Significant Risk"
    }
]`;

// Funding API
const login_funding = `{
    "roles": [
       "Admin"
    ],
   "permissions": {
       "CreateAccount": true,
       "DeleteAccount": true,
       "UpdateAccount": true,
       "GetAccounts": true,
       "MakeRequestScreen": true,
       "ViewAccounts": true,
       "SeeLogs": true,
       "MakeRequest": true,
       "CancelRequest": true,
       "Register": true,
       "FlowCondition": true,
       "ConfigurationSetup": true,
       "CreateAnnouncement": true,
       "UpdateAnnouncement": true,
       "ViewAnnouncement": true
    },
    "token": "eyJhbGciOwDprAniDtcDWnb1R4",
   "expiration": "2023-09-13T07:59:56Z",
   "duoHost": "api-0fe98b2b.duosecurity.com",
   "duoSigRequest": "TX|amF3YWE5OTY=|49db7ce:APP|amF3YTUyOTY=|d5df7c461436",
   "userName": "JohnDoe"
 }`;

const fundRequest = `{ 
    "statusCode": 201,
    "status": true,
    "message": "Fund request created successfully",
    "data": null,
    "fundRequestId": 69,
    "bankingInstructionSetupId": 20
}`;

const fundRequestValidation = `{
    "errors": {
        "Amount": [
            "Should be in proper format. Zero or 0.0 will not be acceptable and maximum range is 15 digits with 6 digits of fractional part"
        ],
        "RequestTypeId": [
            "The field RequestTypeId must be between 1 and 2.",
            "RequestType must be numeric and either 1 or 2",
            "Invalid RequestTypeId, only 1 will be acceptable in RequestTypeId for ACH"
        ],
        "TransactionTypeId": [
            "The field TransactionTypeId must be between 1 and 2.",
            "TransactionTypeId must be numeric and either 1 or 2"
        ],
        "BackOfficeAccountNumber": [
            "BackOfficeAccountNumber is not valid must be like this 1XXX-XXX-000001-X OR 1XXX-2XXX-000001-XX"
        ]
    },
    "type": "https://example.com",  
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-62eafad602319c-00"
}`;

const getAccessToExternalAPICreate = `{
    "statusCode": 201,
    "status": true,
    "message": "Wire Request Created and Auto Approved",
    "data": null,
    "fundRequestId": 197,
    "bankingInstructionSetupId": 75
}`;

const getAccessToExternalAPIAdd = `{
    "statusCode": 201,
    "status": true,
    "message": "Fund Request Created and Auto Approved",
    "data": null,
    "fundRequestId": 261,
    "bankingInstructionSetupId": 75
}`;

const getAccessToExternalAPI = `{
    "statusCode": 201,
    "status": true,
    "message": "Fund request created successfully",
    "data": null,
    "fundRequestId": 504,
    "bankingInstructionSetupId": 213
}`;

const getAccessToExternalAPIValidation = `	{	
    "errors": {	
        "ABA": [	
            "SwiftABA must be alphanumeric"	
        ],	
        "City": [	
            "Can't use special characters in City"	
        ],	
        "Amount": [	
            "Should be in proper format. Zero or 0.0 will not be acceptable and maximum range is 15 digits with 6 digits of fractional part"	
        ],	
        "Account": [	
            "Account must be numeric"	
        ],	
        "StateId": [	
            "State does not exist against the given id"	
        ],	
        "FirstName": [	
            "Can't use digit or special characters except for Dot and Apostrophe in First Name"	
        ],	
        "RequestTypeId": [	
            "RequestType must be numeric and either 1 or 2",	
            "Invalid RequestTypeId, only 1 will be acceptable in RequestTypeId for ACH"	
        ],	
        "BackOfficeAccountNumber": [	
            "BackOfficeAccountNumber is not valid must be like this 1XXX-XXX-000001-X OR 1XXX-2XXX-000001-XX, X is indicating alphabets"	
        ]	
    },	
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",  	
    "title": "One or more validation errors occurred.",	
    "status": 400,	
    "traceId": "00-ac6d19135db43cb45a06c4cfb3afac33-e34459a429999abe-00"	
}`;

const getFundRequestDetails = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful. Data exists against the given id = 5",
    "data": {
        "Id": 5,
        "FirstName": "John",
        "LastName": "Doe",
        "Amount": 9999999999999.99,
        "ReversalFee": 0.0,
        "AccountInfo": "dfdf",
        "AccountTypeId": 1,
        "Account": "645645",
        "BackOfficeAccountNumber": "6534343423544565-5",
        "AccountName": "Example Bank",
        "Address": "14th Street North Bay",
        "ABA": "654656",
        "RoutingCode": "654656",
        "Pending": false,
        "Cancelled": false,
        "Approved": true,
        "Rejected": false,
        "ApprovalStatus": "Approved",
        "Created": "2023-02-14T07:49:24.797591",
        "LastUpdated": "2023-05-08T10:49:47.100253",
        "RejectReason": "",
        "RequestTypeId": 1,
        "TransactionTypeId": 2,
        "ACHProcessorStatus": null,
        "ACHProcessorReason": null,
        "ACHProcessorActualResponse": null,
        "ACHProcessorTransferID": null,
        "Failed": false,
        "FailedReason": null,
        "BankDetailsMismatch": false
    },
    "id": 5
}`;

const getAllbankingDetailsInst = `	{	
    "statusCode": 200,	
    "status": true,	
    "message": "Banking Instructions exist and fetched",	
    "data": {	
        "Banking Instruction Setups": [	
            {	
                "Id": 20,	
                "FirstName": "John",	
                "LastName": "Doe",	
                "Account": "123456",	
                "BackOfficeAccountNumber": "1Gdfsf5-dfgf-004-M",	
                "AccountName": "Example BANK",	
                "Address": "14th Street North ",	
                "Apt": "H-No 123",	
                "Country": "US",	
                "State": "NY",	
                "City": "Bayharbour",	
                "ZipCode": "10253",	
                "ABA": "AB090078601",	
                "AccountInfo": null,	
                "AccountTypeId": 1,	
                "IsDefault": true,	
                "Created": "2023-08-11T07:56:40.43804"	
            }	
        ]	
    },	
    "id": null	
}`;

const getAllAuditTrails = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful. Data exists",
    "data": {
      "“CurrentPage“": 1,
      "“PageSize\"\"": 100,
      "NextPage": 2,
      "Data": [
        {
          "Id": 1417,
          "RequestId": 368,
          "FirstName": "Jhon",
          "LastName": "Doe",
          "Amount": 49999,
          "Account": "1111",
          "BackOfficeAccountNumber": "1GDN-GDN-088750-C",
          "AccountInfo": null,
          "AccountTypeId": 2,
          "AccountName": "Plaid Silver Standard 0.1% Interest Saving",
          "Address": "Scottish Highlands",
          "Apt": null,
          "Country": "233",
          "State": "3077",
          "City": "Hazlet",
          "ZipCode": "07730",
          "ABA": "011401533",
          "RoutingCode": null,
          "Status": "Execution Successfull",
          "CreatedBy": "GuardianUser",
          "Action": "Execution Successfull",
          "ActionBy": "Internal User",
          "Created": "2023-06-09T14:48:50.862327",
          "LastUpdated": "2023-06-12T14:2:08.126816",
          "Reason": "Transaction Executed Scucessfully",
          "RequestTypeId": 1,
          "TransactionTypeId": 2,
          "FirmName": "Guardian",
          "ACHProcessorStatus": "Transaction Executed Scucessfully",
          "Requestee": "Professor Dumbeldore"
        }
      ]
    }
  
  }`;

const getAllAuditTrailsByDate = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful. Data exists ",
    "data": {
      "CurrentPage": 1,
      "PageSize": 5,
      "PreviousPage": 0,
      "NextPage": 2,
      "Data": [
        {
          "Id": 1963,
          "RequestId": 503,
          "FirstName": "John",
          "LastName": "Doe",
          "Amount": 50000.0,
          "Account": "0000",
          "BackOfficeAccountNumber": "1GDN-GDsxsds-00091-M",
          "AccountInfo": null,
          "AccountTypeId": 1,
          "AccountName": "Example BANK",
          "Address": "14th Street North Bay",
          "Apt": "H-No 789",
          "Country": "233",
          "State": "3077",
          "City": "Bayharbour",
          "ZipCode": "10253",
          "ABA": "090078601",
          "RoutingCode": null,
          "Status": "Pending",
          "CreatedBy": "Admin",
          "Action": "Approved",
          "ActionBy": "Internal User",
          "Created": "2023-07-26T12:37:36.883343",
          "LastUpdated": "2023-07-27T08:33:31.389642",
          "Reason": "",
          "RequestTypeId": 1,
          "TransactionTypeId": 1,
          "FirmName": "Internal",
          "ACHProcessorStatus": null,
          "Requestee": "John Doe"
        }
      ]
    }
  }
`;

const getAllFundRequests = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful fetched all the fund requests",
    "data": {
      “CurrentPage“: 1,
      “PageSize"": 1000,
      "NextPage": 2,
      "Data": [
        {
          "Id": 5,
          "FirstName": "John",
          "LastName": "Doe",
          "Amount": 3333333333,
          "ReversalFee": 0.0,
          "AccountInfo": "john_doe",
          "AccountTypeId": 1,
          "Account": "645645",
          "BackOfficeAccountNumber": "6565-464-645645-5",
          "AccountName": "Example BANK ",
          "Address": "14th Street North Bay",
          "Apt": "AB-47",
          "Country": "",
          "State": "",
          "City": "",
          "ZipCode": "",
          "ABA": "654656",
          "RoutingCode": "654656",
          "Pending": false,
          "Cancelled": false,
          "Approved": true,
          "Rejected": false,
          "ApprovalStatus": "Approved",
          "Created": "2023-02-14T07:49:24.797591",
          "LastUpdated": "2023-05-08T10:49:47.100253",
          "RejectReason": "",
          "RequestTypeId": 1,
          "TransactionTypeId": 2,
          "ACHProcessorStatus": null,
          "ACHProcessorReason": null,
          "ACHProcessorActualResponse": null,
          "ACHProcessorTransferID": null,
          "Failed": false,
          "FailedReason": null,
          "BankDetailsMismatch": false
        }
      ]
    }
  
  }`;

const getAllBankInstruction = `{
    "statusCode": 200,
    "status": true,
    "message": "Banking Instructions exist and fetched",
    "data": {
        "Banking Instruction Setups": [
            {
                "Id": 66,
                "FirstName": "Ram",
                "LastName": "Paul",
                "Account": "0000",
                "BackOfficeAccountNumber": "1Gssd-sdsd-0777-E",
                "AccountName": "Example BANK",
                "Address": "614 Courthouse Circle",
                "ABA": "52525252",
                "AccountInfo": "Info of Ram account and this is the defalt account aganist BO 1GDasdsad-0007-K and UserId",
                "AccountTypeId": 1,
                "IsDefault": true,
                "Created": "2022-10-13T12:13:06.798791"
            },
            {
                "Id": 70,
                "FirstName": "Ram",
                "LastName": "Paul",
                "Account": "0000",
                "BackOfficeAccountNumber": "1GDasadasd-asdasdas0777-E",
                "AccountName": "Example bank",
                "Address": "14th Street North Bay",
                "ABA": "52525252",
                "AccountInfo": "Info of Ram account and this is the defalt account aganist BO 1GDasda-sd007-K and UserId",
                "AccountTypeId": 1,
                "IsDefault": true,
                "Created": "2022-10-18T13:33:40.267952"
            }
        ]
    },
    "id": null
}`;
const getallsingle = `{
        "statusCode": 200,
        "status": true,
        "message": "Successful fetched all the fund requests",
        "data": {
          “CurrentPage“: 1,
          “PageSize"": 1000,
          "NextPage": 2,
          "Data": [
            {
              "Id": 5,
              "FirstName": "John",
              "LastName": "Doe",
              "Amount": 9999999999999.99,
              "ReversalFee": 0.0,
              "AccountInfo": "dfdf",
              "AccountTypeId": 1,
              "Account": "645645",
              "BackOfficeAccountNumber": "6565-464-645645-5",
              "AccountName": "Example BANK",
              "Address": "14th Street North Bay",
              "Apt": "AB-47",
              "Country": "",
              "State": "",
              "City": "",
              "ZipCode": "",
              "ABA": "654656",
              "RoutingCode": "654656",
              "Pending": false,
              "Cancelled": false,
              "Approved": true,
              "Rejected": false,
              "ApprovalStatus": "Approved",
              "Created": "2023-02-14T07:49:24.797591",
              "LastUpdated": "2023-05-08T10:49:47.100253",
              "RejectReason": "",
              "RequestTypeId": 1,
              "TransactionTypeId": 2,
              "ACHProcessorStatus": null,
              "ACHProcessorReason": null,
              "ACHProcessorActualResponse": null,
              "ACHProcessorTransferID": null,
              "Failed": false,
              "FailedReason": null,
              "BankDetailsMismatch": false
            }
          ]
        }
      
      }`;

const getSpecificfundRequests = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful fetched all the fund requests",
    "data": {
      “CurrentPage“: 1,
      “PageSize"": 50,
      "NextPage": 2,
      "Data": [
        {
          "Id": 5,
          "FirstName": "john",
          "LastName": "Doe",
          "Amount": 50000,
          "ReversalFee": 0.0,
          "AccountInfo": "dfdf",
          "AccountTypeId": 1,
          "Account": "645645",
          "BackOfficeAccountNumber": "6565-464-645645-5",
          "AccountName": "Example bank",
          "Address": "14th Street North Bay",
          "Apt": "AB-47",
          "Country": "",
          "State": "",
          "City": "",
          "ZipCode": "",
          "ABA": "654656",
          "RoutingCode": "654656",
          "Pending": false,
          "Cancelled": false,
          "Approved": true,
          "Rejected": false,
          "ApprovalStatus": "Approved",
          "Created": "2023-02-14T07:49:24.797591",
          "LastUpdated": "2023-05-08T10:49:47.100253",
          "RejectReason": "",
          "RequestTypeId": 1,
          "TransactionTypeId": 2,
          "ACHProcessorStatus": null,
          "ACHProcessorReason": null,
          "ACHProcessorActualResponse": null,
          "ACHProcessorTransferID": null,
          "Failed": false,
          "FailedReason": null,
          "BankDetailsMismatch": false
        }
      ]
    }
  
  }`;
// Trading API
const login_trading_api = `{
    "access_token": "eyJhbGciOiJSUzI1I6MTY2ODE2NTg5MiwiaXNzIjoiaHRo268PzDP1biDmV8SMyWDPQ0cDovL2xvY2FsaG9zdDo4iOiIxMCIsInN1YiUiOjE2NjgxNjUyOTIsImlkcCI6ImxvY2K84vnRrMjBlv8EAtYeaUddNZ4",
    "expires_in": 600,
    "token_type": "Bearer",
    "refresh_token": "C3A7B6193250E233734",
    "scope": "marketdata-api offline_access oms-api"
}`;

const static_data_accounts = `{
    "success": true,
    "message": "",
    "data": {
        "eventType": -1,
        "eventData": [
            {
                "isBoxVsShort": false,
                "cmtas": [],
                "name": "account1",
                "value": "account1",
                "booth": "booth_one"
            }
        ]
    }
}`;

const renew_access_token = `{
    {
        "access_token": "IjAGceyJhbxv_URIJnFHD7ngMPuEe5-wROUZPQ",
        "expires_in": 600,
        "token_type": "Bearer",
        "refresh_token": "A748642FDD236CA4FCEE4B5DA10B13874860108F0F",
        "scope": "marketdata-api oms-api offline_access"
    }
}`;
const static_data_account = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "John Doe",
            "value": "jhondoe",
            "booth": "LSL"
        }
    ]
}`;

const static_data_side = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "BUY",
            "value": "1",
            "booth": null
        },
        {
            "name": "SELL",
            "value": "2",
            "booth": null
        },
        {
            "name": "SS",
            "value": "5",
            "booth": null
        }
    ]
}`;

const static_data_tif = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "Day",
            "value": "0",
            "booth": null
        },
        {
            "name": "GTC",
            "value": "1",
            "booth": null
        },
        {
            "name": "OPG",
            "value": "2",
            "booth": null
        },
        {
            "name": "IOC",
            "value": "3",
            "booth": null
        },
        {
            "name": "FOK",
            "value": "4",
            "booth": null
        }
    ]
}`;

const static_data_order_type = `{
        "eventType": -1,
        "eventData": [
            {
                "name": "MKT",
                "value": "1",
                "booth": null
            },
            {
                "name": "LMT",
                "value": "2",
                "booth": null
            },
            {
                "name": "STOP",
                "value": "3",
                "booth": null
            },
            {
                "name": "STOP LMT",
                "value": "4",
                "booth": null
            }
        ]
    }`;

const static_data_locate_tif = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "IOC",
            "value": "3",
            "booth": null
        },
        {
            "name": "FOK",
            "value": "4",
            "booth": null
        }
    ]
}`;

const static_data_destination = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "NYSE",
            "value": "NYSE",
            "booth": null
        },
        {
            "name": "ARCA",
            "value": "ARCA",
            "booth": null
        }
    ]
}`;

const orders_orders = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-5fce3562ecadbcc3f26e-00",
    "errors": {
        "Account": [
            "Invalid account selected"
        ]
    }
}`;

const orders_update = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-01be0fbd-170bdd212e0d4d48-00",
    "errors": {
        "OrderQty": [
            "Invalid quantity"
        ]
    }
}
`;
const orders_cancel = `
{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-01be0fb22f-170bdd212e0d4d48-00",
    "errors": {
        "PropertyName": [
            "Validation Message for the property"
        ]
    }
}`;

const option_order_post = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-0d5ecd5-6007c663e0263586-00",
    "errors": {
        "Account": [
            "Invalid account selected"
        ]
    }
}`;

const option_order_update = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-760f72a527c9b8d5fc5e2-00",
    "errors": {
        "OrdType": [
            "Invalid orderType"
        ]
    }
}`;

const option_order_cancel = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-0d5eca05-6007c663e0263586-00",
    "errors": {
        "Account": [
            "Invalid account selected"
        ]
    }
}`;

const locate_request = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-4f9bf2d297ff7362bd100d4-00",
    "errors": {
        "OrderQty": [
            "Invalid quantity"
        ]
    }
}`;

const locate_acquire = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-de6ad3c62ade89add37149c-00",
    "errors": {
        "TimeInForce": [
            "Invalid time in force selected"
        ]
    }
}`;

// Journal API

const journal_success_response = `{
  "roles": [
        "role"
    ],
    "permissions": {
        "permission": true
    },
    "token": "Token",
    "expiration": "2025-05-15T06:52:05Z",
    "userName": "username"
}`;

const post_journal_entry_success_response = `{
  "isSuccess": true,
  "errorMessage": null
}`;

const post_journal_entry_batch_success_response = `{
  "isSuccess": true,
  "errorMessage": null
}`;

// vFlux Events API

const vflux_login_response = `{
  "statusCode": null,
  "status": true,
  "message": "string",
  "id": null,
  "data": {
    "role": "",
    "token": "string",
    "expiration": "string",
    "isCorrApprover": false,
    "filterPermission": null,
    "refreshToken": {
      "token": "string",
      "tokenExpiration": "string"
    }
  },
  "count": 0
}`;

const vflux_get_events_response = `{
  "errors": [
    "string"
  ],
  "isSuccess": true,
  "message": "string",
  "data": [
    {
      "expirationTime": "string",
      "expirationDate": "string",
      "assetClass": "string",
      "anticipatedPaymentDate": "string",
      "protectExpirationDate": "string",
      "effectiveDate": "string",
      "cusip": "string",
      "eventType": "string",
      "exDate": "string",
      "grossRate": "string",
      "mandatory_Voluntary": "string",
      "payoutRate": "string",
      "positionCaptureDate": "string",
      "processorsComments": "string",
      "recordDate": "string",
      "securityDescription": "string",
      "taxRate": "string",
      "tickerSymbol": "string",
      "payDate": "string"
    }
  ],
  "statusCode": 0
}`;

export default {
  account_opening: {
    login_account_opening,
    list_all_resp_body,
    get_options_details,
    companyInitialRouteUrl,
    beneficiaryRouteUrl,
    fundingRouteUrl,
    signupInitialRouteUrl,
    signupAccountRouteUrl,
    signupOtherRouteUrl,
    allAccountRouteURL,
    filterAccountRouteURL,
    documentlist,
    singleDocLink,
    apiOptionListAll,
    apiOptionDetails,
  },
  funding: {
    login_funding,
    fundRequest,
    fundRequestValidation,
    getAccessToExternalAPICreate,
    getAccessToExternalAPIAdd,
    getAccessToExternalAPI,
    getAccessToExternalAPIValidation,
    getFundRequestDetails,
    getAllbankingDetailsInst,
    getAllAuditTrailsByDate,
    getAllAuditTrails,
    getAllFundRequests,
    getAllBankInstruction,
    getallsingle,
    getSpecificfundRequests,
  },

  trading: {
    login_trading_api,
    static_data_accounts,
    renew_access_token,
    static_data_account,
    static_data_side,
    static_data_tif,
    static_data_order_type,
    static_data_locate_tif,
    static_data_destination,
    orders_orders,
    orders_update,
    orders_cancel,
    option_order_post,
    option_order_update,
    option_order_cancel,
    locate_request,
    locate_acquire,
  },

  journal: {
    journal_success_response,
    post_journal_entry_success_response,
    post_journal_entry_batch_success_response,
  },

  vflux: {
    vflux_login_response,
    vflux_get_events_response,
  },

  grisk: {
    grisk_authenticate_response: `{
  "isSuccess": true,
  "errors": [],
  "role": "BrandNewRole",
  "idleTimeout": 100,
  "loginTFA": false,
  "message": "Login successful.",
  "data": {
    "userId": "value",
    "userName": "UserName",
    "clientName": "Risk-API",
    "email": "user@example.com",
    "accessToken": "token",
    "refreshToken": "refresh-token",
    "refreshTokenExpiration": "2025-12-30T18:08:16.1696316+05:00",
    "accessTokenExpiration": "2025-12-30T18:08:16.1696316+05:00",
    "sessionID": "value"
  },
  "passwordExpirationDaysRemaining": "82"
}`,
    grisk_validate_otp_response: `{
  "isSuccess": true,
  "errors": [],
  "role": "UserAssignedRole",
  "idleTimeout": 100,
  "loginTFA": true,
  "message": "verification Code",
  "data": {
    "userId": "value",
    "userName": "Alex",
    "clientName": "Risk-API",
    "email": "user@example.com",
    "Code": "12345"
  }
}`,
    grisk_resend_otp_response: `{
  "isSuccess": true,
  "errors": [],
  "role": "UserAssignedRole",
  "idleTimeout": 100,
  "loginTFA": true,
  "message": "Verification code sent on email",
  "data": {
    "userId": "value",
    "userName": "UserName",
    "clientName": "Risk-API",
    "email": "user@example.com",
    "Code": "12345"
  }
}`,
    grisk_refresh_token_response: `{
  "isSuccess": true,
  "errors": [],
  "idleTimeout": 0,
  "loginTFA": false,
  "message": "Access token refreshed successfully.",
  "data": {
    "userId": "80d2a982-cb67-4aff-bbac-b7af64438263",
    "userName": "value",
    "clientName": "value",
    "email": "user@example.com",
    "accessToken": "<new JWT access token>",
    "refreshToken": "refresh-token",
    "refreshTokenExpiration": "2026-01-04T21:58:04.9645222+05:00",
    "accessTokenExpiration": "2026-01-04T21:58:04.9645222+05:00",
    "sessionID": "159ef07b-e054-448b-ba22-6b0dc8b1766f"
  }
}`,
    grisk_create_risk_profile_response: `{
  "id": "PKUXKY10009",
  "name": "PKUXKY10009",
  "pre_trade_policies": [
    { "id": "Suspended", "type": 4, "cfg": [], "action": { "type": 0 } },
    { "id": "Liquidation Only", "type": 3, "cfg": [], "action": { "type": 0 } },
    {
      "id": "Min ADV Required #",
      "type": 5,
      "cfg": [{ "key": "threshold", "val": "12" }],
      "action": { "type": 0 }
    }
  ],
  "post_trade_policies": [
    {
      "id": "Max Position Size per Symbol ADV%",
      "type": 6,
      "layers": [
        { "action": { "type": 2 }, "cfg": [{ "key": "adv%", "val": 100.0 }] }
      ]
    },
    {
      "id": "Position Exposure Limit per Symbol Equity %",
      "type": 8,
      "layers": [
        { "action": { "type": 0 }, "cfg": [{ "key": "equity%", "val": 666.0 }] }
      ]
    }
  ],
  "used_by": { "firms": [], "groups": [], "traders": [] },
  "assigned_firm": 0,
  "assigned_group": 0,
  "assigned_account": 0,
  "createdDate": "2025-07-04T09:12:47.5457295Z"
}`,
    grisk_get_all_risk_profiles_response: `{
  "data": [
    {
      "id": "ABCProfile",
      "name": "ABCProfile",
      "pre_trade_policies": [
        { "id": "Suspended", "type": 4, "cfg": [], "action": { "type": 0 } },
        { "id": "Liquidation Only", "type": 3, "cfg": [], "action": { "type": 0 } }
      ],
      "post_trade_policies": [],
      "used_by": {
        "firms": ["AuditTestProfile01"],
        "groups": ["AuditTestProfile01_Default"],
        "traders": []
      },
      "assigned_firm": 1,
      "assigned_group": 1,
      "assigned_account": 0,
      "createdDate": "2025-04-28T12:06:23.833748",
      "updatedDate": "2025-05-22T11:10:54.048239"
    },
    {
      "id": "IALI_01",
      "name": "IALI_01",
      "pre_trade_policies": [
        { "id": "Suspended", "type": 4, "cfg": [], "action": { "type": 0 } },
        { "id": "Liquidation Only", "type": 3, "cfg": [], "action": { "type": 0 } }
      ],
      "post_trade_policies": [],
      "used_by": {
        "firms": [],
        "groups": ["TRG-1", "TRG-3434341"],
        "traders": []
      },
      "assigned_firm": 0,
      "assigned_group": 2,
      "assigned_account": 0,
      "createdDate": "2025-05-21T11:51:39.126967",
      "updatedDate": "2025-06-11T09:00:04.889362"
    }
  ]
}`,
    grisk_get_risk_profile_by_id_response: `{
  "data": [
    {
      "id": "ABCProfile",
      "name": "ABCProfile",
      "pre_trade_policies": [
        { "id": "Suspended", "type": 4, "cfg": [], "action": { "type": 0 } },
        { "id": "Liquidation Only", "type": 3, "cfg": [], "action": { "type": 0 } }
      ],
      "post_trade_policies": [],
      "used_by": {
        "firms": ["AuditTestProfile01"],
        "groups": ["AuditTestProfile01_Default"],
        "traders": []
      },
      "assigned_firm": 1,
      "assigned_group": 1,
      "assigned_account": 0,
      "createdDate": "2025-04-28T12:06:23.833748",
      "updatedDate": "2025-05-22T11:10:54.048239"
    },
      "assigned_firm": 0,
      "assigned_group": 2,
      "assigned_account": 0,
      "createdDate": "2025-05-21T11:51:39.126967",
      "updatedDate": "2025-06-11T09:00:04.889362"
    }
  ]
}`,
    grisk_get_all_policies_response: `[
  "Min ADV Required",
  "Opening Order QTY ADV %",
  "Closing Order QTY ADV %",
  "MKT Opening Order QTY ADV %",
  "MKT Closing Order QTY ADV %",
  "Total Trades ADV %",
  "Open Orders ADV %",
  "Total Trades Shares limit",
  "Open Order Shares Limit",
  "Trades + Open Orders Shares Limit",
  "Open Order Count Limit",
  "Open Orders Count Limit per Security",
  "Max Bid/Ask Layers For Open Orders",
  "Max Share Price",
  "Min Share Price",
  "Max Order Price Deviation %",
  "Order Notional Limit",
  "Order QTY Limit",
  "Min Cancel Time",
  "MOC Order Notional Limit",
  "MOC Order QTY Limit",
  "MOO Order Notional Limit",
  "MOO Order QTY Limit",
  "Options Buy Order Qty Limit",
  "Options Sell Short Order Qty Limit",
  "Options Zero DTE Buy Order Qty Limit",
  "Options Zero DTE Sell Short Order Qty Limit",
  "Options Symbol Buy Order Qty Limit",
  "Options Symbols Sell Short Order Qty Limit",
  "Options Order Price Check %",
  "Min Options Order Price",
  "Max Options Order Price",
  "Max Options Open Orders Count",
  "Min Options Open Orders Count",
  "Min Options Order Cancel Time",
  "Restricted Symbol",
  "Restricted Options Contracts",
  "Max Equities Order Duplicates Count in Time Frame",
  "Max Options Order Duplicates Count in Time Frame",
  "Equities Aggressive Price Check",
  "Options Aggressive Price Check",
  "Equities Passive Price Check",
  "Options Passive Price Check",
  "\\"Gross notional cumulative\\" limit (executed+open orders) pre-trade policy",
  "\\"Net notional cumulative\\" limit (executed+open orders) pre-trade policy",
  "Trading halted",
  "Min price increment",
  "Loss Limit $",
  "Loss Limit %",
  "Loss Limit Sym $",
  "Loss Limit Sym %",
  "Max Position Size per Symbol",
  "Max Position Size per Symbol ADV%",
  "Position Exposure Limit $ per Symbol",
  "Position Exposure Limit per Symbol Equity %",
  "Max L/S position exposure $",
  "Max L/S position exposure %",
  "Total position exposure $",
  "Total position exposure X",
  "Max L/S orders exposure $",
  "Max L/S orders exposure X",
  "Total orders exposure $",
  "Total orders exposure X",
  "Max L/S combined exposure $",
  "Max L/S combined exposure X",
  "Total combined exposure $",
  "Total combined exposure X"
]`,
    grisk_update_risk_profile_response: `{
  "id": "Regress2",
  "name": "Regress2",
  "pre_trade_policies": [
    { "id": "Suspended", "type": 4, "cfg": [], "action": { "type": 0 } },
    { "id": "Liquidation Only", "type": 3, "cfg": [], "action": { "type": 0 } },
    {
      "id": "Options Zero DTE Sell Short Order QTY Limit #",
      "type": 38,
      "cfg": [{ "key": "threshold", "val": "50" }],
      "action": { "type": 0 }
    },
    {
      "id": "Restricted Symbol",
      "type": 33,
      "cfg": [{ "key": "blacklist", "val": "SSSS" }],
      "action": { "type": 0 }
    },
    {
      "id": "Order QTY Limit #",
      "type": 22,
      "cfg": [{ "key": "threshold", "val": "50" }],
      "action": { "type": 0 }
    }
  ],
  "post_trade_policies": [
    {
      "id": "Max Position Size per Symbol",
      "type": 5,
      "layers": [
        { "action": { "type": 2 }, "cfg": [{ "key": "threshold", "val": 50 }] }
      ]
    }
  ],
  "used_by": { "firms": [], "groups": [], "traders": [] },
  "assigned_firm": 0,
  "assigned_group": 0,
  "assigned_account": 0,
  "createdDate": "2025-05-21T13:48:06.014378",
  "updatedDate": "2025-07-04T15:18:21.1672942Z"
}`,
    grisk_validate_symbol_file_response: `{
  "validSymbols": ["IBM", "AAAA", "SSS"],
  "invalidSymbols": ["c333"]
}`,
    grisk_create_margin_profile_response: `{
  "createdDate": "2025-07-07T16:11:50.4353667Z",
  "used_by": { "firms": [], "groups": [], "traders": [] },
  "assigned_firm": 0,
  "name": "TestMarginProfile012",
  "id": "TestMarginProfile012",
  "symbol_overrides": [],
  "maint_options_house_min_rate": 30.0,
  "maint_index_options_house_short_rate": 30.0,
  "maint_stock_options_house_short_rate": 30.0,
  "maint_stocks_house_short_rate": 30.0,
  "maint_stocks_house_Long_rate": 30.0,
  "initial_stocks_day_min_requirement": 40.0,
  "initial_stocks_regt_ovn_rate": 50.0,
  "initial_stocks_regt_day_rate": 25.0,
  "initial_stock_options_regt_short_rate": 20.0,
  "initial_index_options_regt_short_rate": 15.0,
  "initial_options_regt_min_rate": 10.0,
  "maint_stocks_regt_Long_rate": 25.0,
  "maint_stocks_regt_short_rate": 30.0,
  "maint_stock_under_2_5_regt_short_per_share": 2.5,
  "maint_stock_under_5_0_regt_short_rate": 100.0,
  "maint_stock_under_X_regt_short_per_share": 5.0,
  "maint_stock_options_regt_short_rate": 20.0,
  "maint_index_options_regt_short_rate": 15.0,
  "maint_options_regt_min_rate": 10.0,
  "createdTime": "2025-07-08T00:00:00Z",
  "updatedTime": "2025-07-08T00:00:00Z"
}`,
    grisk_get_margin_profile_by_id_response: `{
  "createdDate": "2025-07-07T16:11:50.4353667Z",
  "used_by": { "firms": [], "groups": [], "traders": [] },
  "assigned_firm": 0,
  "name": "TestMarginProfile012",
  "id": "TestMarginProfile012",
  "symbol_overrides": [],
  "maint_options_house_min_rate": 30.0,
  "maint_index_options_house_short_rate": 30.0,
  "maint_stock_options_house_short_rate": 30.0,
  "maint_stocks_house_short_rate": 30.0,
  "maint_stocks_house_Long_rate": 30.0,
  "initial_stocks_day_min_requirement": 40.0,
  "initial_stocks_regt_ovn_rate": 50.0,
  "initial_stocks_regt_day_rate": 25.0,
  "initial_stock_options_regt_short_rate": 20.0,
  "initial_index_options_regt_short_rate": 15.0,
  "initial_options_regt_min_rate": 10.0,
  "maint_stocks_regt_Long_rate": 25.0,
  "maint_stocks_regt_short_rate": 30.0,
  "maint_stock_under_2_5_regt_short_per_share": 2.5,
  "maint_stock_under_5_0_regt_short_rate": 100.0,
  "maint_stock_under_X_regt_short_per_share": 5.0,
  "maint_stock_options_regt_short_rate": 20.0,
  "maint_index_options_regt_short_rate": 15.0,
  "maint_options_regt_min_rate": 10.0,
  "createdTime": "2025-07-08T00:00:00Z",
  "updatedTime": "2025-07-08T00:00:00Z"
}`,
    grisk_get_all_margin_profiles_response: `{
  "data": [
    {
      "createdDate": "2025-04-28T12:00:32.657464",
      "updatedDate": "2025-07-04T13:09:49.450442",
      "used_by": { "firms": [], "groups": [], "traders": [] },
      "assigned_firm": 0,
      "name": "TestMarginProfile",
      "id": "TestMarginProfile",
      "symbol_overrides": [
        {
          "symbol": "IBM",
          "data": {
            "initial_stocks_ovn_Long_rate": 55.0,
            "initial_stocks_ovn_short_rate": 55.0,
            "initial_stocks_day_Long_rate": 55.0,
            "initial_stocks_day_short_rate": 55.0
          }
        }
      ],
      "maint_options_house_min_rate": 30.0,
      "maint_index_options_house_short_rate": 30.0,
      "maint_stock_options_house_short_rate": 30.0,
      "maint_stocks_house_short_rate": 30.0,
      "maint_stocks_house_Long_rate": 25.0,
      "initial_stocks_day_min_requirement": 50.0,
      "initial_stocks_regt_ovn_rate": 50.0,
      "initial_stocks_regt_day_rate": 25.0,
      "initial_stock_options_regt_short_rate": 20.0,
      "initial_index_options_regt_short_rate": 15.0,
      "initial_options_regt_min_rate": 10.0,
      "maint_stocks_regt_Long_rate": 25.0,
      "maint_stocks_regt_short_rate": 30.0,
      "maint_stock_under_2_5_regt_short_per_share": 2.5,
      "maint_stock_under_5_0_regt_short_rate": 100.0,
      "maint_stock_under_X_regt_short_per_share": 5.0,
      "maint_stock_options_regt_short_rate": 20.0,
      "maint_index_options_regt_short_rate": 15.0,
      "maint_options_regt_min_rate": 10.0,
      "createdTime": "2025-07-08T00:00:00Z",
      "updatedTime": "2025-07-08T00:00:00Z"
    },
    {
      "createdDate": "2025-04-28T12:08:09.916655",
      "updatedDate": "2025-07-07T13:30:19.21089",
      "used_by": { "firms": ["new", "TestFirm"], "groups": [], "traders": [] },
      "assigned_firm": 2,
      "name": "TEST09022024",
      "id": "TEST09022024",
      "symbol_overrides": [],
      "maint_options_house_min_rate": 30.0,
      "maint_index_options_house_short_rate": 30.0,
      "maint_stock_options_house_short_rate": 30.0,
      "maint_stocks_house_short_rate": 100.0,
      "maint_stocks_house_Long_rate": 30.0,
      "initial_stocks_day_min_requirement": 80.5,
      "initial_stocks_regt_ovn_rate": 50.0,
      "initial_stocks_regt_day_rate": 25.0,
      "initial_stock_options_regt_short_rate": 20.0,
      "initial_index_options_regt_short_rate": 15.0,
      "initial_options_regt_min_rate": 10.0,
      "maint_stocks_regt_Long_rate": 25.0,
      "maint_stocks_regt_short_rate": 30.0,
      "maint_stock_under_2_5_regt_short_per_share": 2.5,
      "maint_stock_under_5_0_regt_short_rate": 100.0,
      "maint_stock_under_X_regt_short_per_share": 5.0,
      "maint_stock_options_regt_short_rate": 20.0,
      "maint_index_options_regt_short_rate": 15.0,
      "maint_options_regt_min_rate": 10.0,
      "createdTime": "2025-07-08T00:00:00Z",
      "updatedTime": "2025-07-08T00:00:00Z"
    },
    {
      "createdDate": "2025-04-28T12:08:22.941847",
      "updatedDate": "2025-07-04T13:09:49.503389",
      "used_by": { "firms": ["test", "Firm", "LSL", "testfirmvalid", "RSK"], "groups": [], "traders": [] },
      "assigned_firm": 5,
      "name": "TESTTEST",
      "id": "TESTTEST",
      "symbol_overrides": [
        {
          "symbol": "MSFT",
          "data": {
            "initial_stocks_ovn_Long_rate": 50.0,
            "initial_stocks_ovn_short_rate": 50.0,
            "initial_stocks_day_Long_rate": 505.0,
            "initial_stocks_day_short_rate": 50.0
          }
        },
        {
          "symbol": "QQQ",
          "data": {
            "initial_stocks_ovn_Long_rate": 50.0,
            "initial_stocks_ovn_short_rate": 50.0,
            "initial_stocks_day_Long_rate": 50.0,
            "initial_stocks_day_short_rate": 50.0
          }
        }
      ],
      "maint_options_house_min_rate": 30.0,
      "maint_index_options_house_short_rate": 30.0,
      "maint_stock_options_house_short_rate": 30.0,
      "maint_stocks_house_short_rate": 46.0,
      "maint_stocks_house_Long_rate": 62.0,
      "initial_stocks_day_min_requirement": 100.0,
      "initial_stocks_regt_ovn_rate": 50.0,
      "initial_stocks_regt_day_rate": 25.0,
      "initial_stock_options_regt_short_rate": 20.0,
      "initial_index_options_regt_short_rate": 15.0,
      "initial_options_regt_min_rate": 10.0,
      "maint_stocks_regt_Long_rate": 25.0,
      "maint_stocks_regt_short_rate": 30.0,
      "maint_stock_under_2_5_regt_short_per_share": 2.5,
      "maint_stock_under_5_0_regt_short_rate": 100.0,
      "maint_stock_under_X_regt_short_per_share": 5.0,
      "maint_stock_options_regt_short_rate": 20.0,
      "maint_index_options_regt_short_rate": 15.0,
      "maint_options_regt_min_rate": 10.0,
      "createdTime": "2025-07-08T00:00:00Z",
      "updatedTime": "2025-07-08T00:00:00Z"
    }
  ]
}`,
    grisk_validate_margin_symbol_file_response: `{
  "validSymbols": [
    {
      "symbol": "A",
      "data": {
        "initial_stocks_ovn_Long_rate": 55.0,
        "initial_stocks_ovn_short_rate": 55.0,
        "initial_stocks_day_Long_rate": 25.0,
        "initial_stocks_day_short_rate": 55.0
      }
    }
  ],
  "invalidSymbols": [
    {
      "symbol": "122334",
      "data": {
        "initial_stocks_ovn_Long_rate": 55.0,
        "initial_stocks_ovn_short_rate": 55.0,
        "initial_stocks_day_Long_rate": 55.0,
        "initial_stocks_day_short_rate": 55.0
      }
    }
  ]
}`,
    grisk_create_firm_response: `{
  "id": 13,
  "name": "TestFirm",
  "trading_mode": 0,
  "risk_profile": "Default_Risk_Profile",
  "default_group_risk_profile": "Default_Risk_Profile",
  "default_trader_risk_profile": "Default_Risk_Profile",
  "margin_profile": "Default_Margin_Profile",
  "include_pnl_in_excess": 0
}`,
    grisk_update_firm_response: `{
  "id": 13,
  "name": "LSL Updated",
  "trading_mode": 1,
  "risk_profile": "LIVE_RISK",
  "default_group_risk_profile": "LIVE_RISK",
  "default_trader_risk_profile": "LIVE_RISK",
  "margin_profile": "LIVE_MARGIN",
  "include_pnl_in_excess": 1
}`,
    grisk_get_trader_groups_for_firm_response: `{
  "data": [
    {
      "id": 3,
      "trader_group_id": "test_Default",
      "name": "Default",
      "firm_id": "test",
      "trading_mode": 2,
      "risk_profile": "Options7_3_3_21",
      "default_trader_risk_profile": "TEST09022024",
      "createdTime": "2025-04-28",
      "updatedTime": "2025-06-11"
    }
  ],
  "totalCount": -1,
  "groupCount": -1
}`,
    grisk_get_all_firms_response: `{
  "data": [
    {
      "id": 3,
      "firm_id": "test",
      "trading_mode": 0,
      "risk_profile": "Options7_3_3_21",
      "name": "test",
      "default_group_risk_profile": "TEST09022024",
      "default_trader_risk_profile": "TEST09022024",
      "margin_profile": "TESTTEST",
      "include_pnl_in_excess": 1,
      "createdTime": "2025-04-28",
      "updatedTime": "2025-04-28"
    },
    {
      "id": 7,
      "firm_id": "RSK",
      "trading_mode": 0,
      "risk_profile": "Options7_3_3_21",
      "name": "RSK",
      "default_group_risk_profile": "TestProfileNewFields",
      "default_trader_risk_profile": "Options7_3_3_21",
      "margin_profile": "TESTTEST",
      "include_pnl_in_excess": 2,
      "createdTime": "2025-04-28",
      "updatedTime": "2025-07-04"
    }
  ],
  "totalCount": 1,
  "groupCount": 0
}`,
    grisk_get_firm_by_id_response: `{
  "id": 3,
  "firm_id": "test",
  "trading_mode": 0,
  "risk_profile": "Options7_3_3_21",
  "name": "test",
  "default_group_risk_profile": "TEST09022024",
  "default_trader_risk_profile": "TEST09022024",
  "margin_profile": "TESTTEST",
  "include_pnl_in_excess": 1,
  "createdTime": "2025-04-28",
  "updatedTime": ""
}`,
    grisk_create_trader_group_response: `{
  "trader_group_id": "TraderGroup101",
  "name": "TraderGroup101",
  "firm_id": "LSL",
  "trading_mode": 0,
  "risk_profile": "TestRiskProfile",
  "default_trader_risk_profile": "TestRiskProfile",
  "has_equity_allocation": true,
  "account_type": 1,
  "pdt": true,
  "ovn_trading_multiple": 1,
  "day_trading_multiple": 1,
  "createdTime": "Time",
  "updatedTime": "Time",
  "created_time": 0,
  "updated_time": 0
}`,
    grisk_update_trader_group_response: `{
  "Id": 333,
  "trader_group_id": "TraderGroup101",
  "name": "TraderGroup101",
  "firm_id": "LSL",
  "trading_mode": 0,
  "risk_profile": "TestRiskProfile",
  "default_trader_risk_profile": "TestRiskProfile",
  "has_equity_allocation": true,
  "account_type": 1,
  "pdt": true,
  "ovn_trading_multiple": 1,
  "day_trading_multiple": 1,
  "createdTime": "Time",
  "updatedTime": "Time"
}`,
    grisk_get_all_trader_groups_response: `{
  "data": [
    {
      "id": 64,
      "trader_group_id": "TraderGroup101",
      "name": "TraderGroup101",
      "firm_id": "LSL",
      "trading_mode": 0,
      "risk_profile": "TestRiskProfile",
      "default_trader_risk_profile": "TestRiskProfile",
      "has_equity_allocation": true,
      "account_type": 1,
      "pdt": true,
      "ovn_trading_multiple": 1,
      "day_trading_multiple": 1,
      "createdTime": "2025-07-08T00:00:00Z",
      "updatedTime": "2025-07-08T05:12:55Z",
      "created_time": 0,
      "updated_time": 0
    },
    {
      "id": 65,
      "trader_group_id": "TraderGroup102",
      "name": "TraderGroup102",
      "firm_id": "LSL",
      "trading_mode": 0,
      "risk_profile": "TestRiskProfile",
      "default_trader_risk_profile": "TestRiskProfile",
      "has_equity_allocation": true,
      "account_type": 1,
      "pdt": true,
      "ovn_trading_multiple": 1,
      "day_trading_multiple": 1,
      "createdTime": "2025-07-08T00:00:00Z",
      "updatedTime": "2025-07-08T05:12:55Z",
      "created_time": 0,
      "updated_time": 0
    }
  ],
  "totalCount": 2,
  "summary": [],
  "groupCount": 0
}`,
    grisk_get_trader_group_by_id_response: `{
  "data": [
    {
      "id": 65,
      "trader_group_id": "TraderGroup101",
      "name": "TraderGroup101",
      "firm_id": "LSL",
      "trading_mode": 0,
      "risk_profile": "TestRiskProfile",
      "default_trader_risk_profile": "TestRiskProfile",
      "has_equity_allocation": true,
      "account_type": 1,
      "pdt": true,
      "ovn_trading_multiple": 1,
      "day_trading_multiple": 1,
      "createdTime": "2025-07-08T00:00:00Z",
      "updatedTime": "2025-07-08T05:12:55Z",
      "created_time": 0,
      "updated_time": 0
    }
  ],
  "totalCount": 2,
  "summary": [],
  "groupCount": 0
}`,
    grisk_get_traders_in_group_response: `{
  "data": [
    {
      "id": 1401,
      "trader_id": "PK_0101",
      "name": "PK_0101",
      "firm_id": "LSL",
      "group_id": "1233",
      "short_vs_box": true,
      "account_type": 0,
      "pdt": true,
      "ovn_trading_multiple": 2.0,
      "day_trading_multiple": 4.0,
      "trading_mode": 0,
      "created_time": 1752144225000,
      "updated_time": 0
    }
  ],
  "totalCount": 1,
  "groupCount": 0,
  "summary": []
}`,
    grisk_create_trader_response: `{
  "firm_id": "LSL",
  "trader_id": "PK_0014",
  "name": "PK_0014",
  "short_vs_box": true,
  "account_type": 0,
  "pdt": true,
  "ovn_trading_multiple": 2.0,
  "day_trading_multiple": 4.0,
  "trading_mode": 0,
  "risk_profile": "IALI",
  "created_time": 1752144225000,
  "updated_time": 0
}`,
    grisk_create_bulk_traders_response: `[
  {
    "firm_id": "LSL",
    "trader_id": "TR_0015",
    "name": "TR_0015",
    "short_vs_box": true,
    "account_type": 0,
    "pdt": true,
    "ovn_trading_multiple": 2.0,
    "day_trading_multiple": 4.0,
    "trading_mode": 0,
    "risk_profile": "riskprofile",
    "created_time": 1752144225000,
    "updated_time": 0
  },
  {
    "firm_id": "LSL",
    "trader_id": "TR_0014",
    "name": "TR_0014",
    "short_vs_box": true,
    "account_type": 0,
    "pdt": true,
    "ovn_trading_multiple": 2.0,
    "day_trading_multiple": 4.0,
    "trading_mode": 0,
    "risk_profile": "riskprofile",
    "created_time": 1752144225000,
    "updated_time": 0
  }
]`,
    grisk_create_traders_csv_response: `{
  "total": 50,
  "succeeded": 50,
  "failed": 0
}`,
    grisk_get_all_trader_response: `{
  "data": [
    {
      "firm_id": "test",
      "id": 5,
      "trader_id": "Prod_Test2",
      "name": "Prod_Test2",
      "group_id": "ABC",
      "short_vs_box": true,
      "account_type": 0,
      "pdt": true,
      "ovn_trading_multiple": 2.0,
      "day_trading_multiple": 4.0,
      "trading_mode": 0,
      "risk_profile": "TEST09022024",
      "created_time": 1752144225000,
      "updated_time": 0
    },
    {
      "firm_id": "test",
      "id": 7,
      "trader_id": "Test1",
      "name": "Test1",
      "group_id": "ABC",
      "short_vs_box": true,
      "account_type": 3,
      "pdt": true,
      "ovn_trading_multiple": 2.0,
      "day_trading_multiple": 4.0,
      "trading_mode": 0,
      "risk_profile": "TEST09022024",
      "created_time": 1752144225000,
      "updated_time": 0
    },
    {
      "firm_id": "LSL",
      "id": 12809,
      "trader_id": "PK_0012934",
      "name": "PK_0012934",
      "group_id": "LSL_Default",
      "short_vs_box": true,
      "account_type": 0,
      "pdt": true,
      "ovn_trading_multiple": 2.0,
      "day_trading_multiple": 4.0,
      "trading_mode": 0,
      "risk_profile": "IALI",
      "created_time": 1752144225000,
      "updated_time": 0
    }
  ],
  "totalCount": -1,
  "groupCount": -1
}`,
    grisk_update_trader_response: `{
  "id": 12813,
  "trader_id": "PK_0016",
  "group_id": "LSL_Default",
  "firm_id": "LSL",
  "short_vs_box": true,
  "trading_mode": 0,
  "risk_profile": "risk_profile",
  "name": "PK_0016",
  "account_type": 0,
  "pdt": true,
  "ovn_trading_multiple": 2.0,
  "day_trading_multiple": 4.0,
  "created_time": 1752144225000,
  "updated_time": 0
}`,
    grisk_update_trader_mode_response: `{
  "trading_mode": 0
}`,
    grisk_get_trader_by_id_response: `{
  "id": 12812,
  "trader_id": "PK_0014",
  "group_id": "LSL_Default",
  "firm_id": "LSL",
  "short_vs_box": true,
  "trading_mode": 0,
  "risk_profile": "IALI",
  "name": "PK_0014",
  "account_type": 0,
  "pdt": true,
  "ovn_trading_multiple": 2.0,
  "day_trading_multiple": 4.0,
  "created_time": 1752144225000,
  "updated_time": 0
}`,
    grisk_get_traders_by_firm_response: `{
  "id": 12812,
  "trader_id": "PK_0014",
  "group_id": "LSL_Default",
  "firm_id": "LSL",
  "short_vs_box": true,
  "trading_mode": 0,
  "risk_profile": "IALI",
  "name": "PK_0014",
  "account_type": 0,
  "pdt": true,
  "ovn_trading_multiple": 2.0,
  "day_trading_multiple": 4.0,
  "created_time": 07-07-2025,
  "updated_time": 0
}`,
    grisk_get_trader_state_response: `{
  "sod_equity": 0.0,
  "current_equity": 357778.25,
  "sod_ovn_excess": 0.0,
  "sod_day_excess": 0.0,
  "sod_ovn_buying_power": 0.0,
  "sod_day_buying_power": 0.0,
  "current_ovn_excess": 356778.25,
  "current_day_excess": -666.6667,
  "current_ovn_bp": 713556.5,
  "current_day_bp": -2000.0,
  "intraday_equity_adjustment": 357778.25
}`,
  },
};
